import axios from 'axios';

import { mapAgentFromApiModel } from './agentDataMapper';
import { buildApiV2Url, nocacheParameter } from '../../../api/utils/apiUtils';
import { generateApiError } from '../../../api/utils/apiErrorMessages';

const getAgent = () =>
  axios
    .get(buildApiV2Url('users/me', nocacheParameter))
    .catch(generateApiError())
    .then(mapAgentFromApiModel);

export default getAgent;
